import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const EclipseContextExtension = ModuleExtensions.contextExtension({
  basename: '',
  userId: '',
  locale: 'en',
  clientId: '',
  siteGuid: '',
  siteAuthorizationType: 'unauthorized',
  purchaseContextOverride: {}
});
//# sourceMappingURL=eclipse-context.extension.js.map